import { render } from "./BlListFilterSearchPhone.vue?vue&type=template&id=c28b3a34&scoped=true"
import script from "./BlListFilterSearchPhone.vue?vue&type=script&lang=js"
export * from "./BlListFilterSearchPhone.vue?vue&type=script&lang=js"

import "./BlListFilterSearchPhone.vue?vue&type=style&index=0&id=c28b3a34&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28b3a34"]])

export default __exports__